// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hint .hint-wrapper > span[data-v-a7019a16] {\n  margin-left: 15px;\n}", ""]);
// Exports
module.exports = exports;
